export const deliverableAndImpactHeadings = [
	{ label: "" },
	{ label: "S.no" },
	{ label: "Name" },
	{ label: "Category" },
	{ label: "Target" },
	{ label: "Achieved" },
	{ label: "Progess" },

	{ label: "" }, //edit icon
];

export const deliverableAndimpactTracklineHeading = [
	{ label: "S.no" },
	{ label: "Date" },
	{ label: "Note" },
	{ label: "Achieved" },
	{ label: "" }, //edit icon
];
